import { Form, Input } from 'antd';
import { passportIdExists } from '../impactAPISlice';

export function PassportIdInput(props: {
  setValue: (newValue: string | null) => void | any;
}) {
  const [form] = Form.useForm();
  return (
    <div style={{ width: 400 }}>
      <Form form={form} style={{ width: '100%' }}>
        <Form.Item
          hasFeedback
          name={'passportId'}
          validateDebounce={1000}
          rules={[
            {
              required: true,
              message: 'This field is required'
            },
            {
              validator: async (_rule, value) => {
                const result = await passportIdExists(value);
                if (!result) {
                  props.setValue(null);
                  return Promise.reject();
                }

                props.setValue(value);
                return Promise.resolve();
              },
              message: 'ImPACT PassportID is incorrect or does not exist'
            }
          ]}
        >
          <Input
            data-private="lipsum"
            placeholder="Insert your ImPACT PassportID here"
          />
        </Form.Item>
      </Form>
    </div>
  );
}
